var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parallax",class:{'shadowed':_vm.b.box_shadow}},[_c('div',{staticClass:"para",style:({backgroundImage:`url(${_vm.b.bild.url})`})})])
}
var staticRenderFns = []

export { render, staticRenderFns }